var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80804 5.27493L0.670208 9.94446C0.472116 10.0457 0.204464 10.0047 0.0723964 9.85286C0.0251927 9.79854 0 9.73476 0 9.66953V0.330436C0 0.147936 0.193005 0 0.431085 0C0.51619 0 0.599398 0.0193107 0.670208 0.0554935L9.80804 4.72502C10.0061 4.82626 10.0596 5.03147 9.92754 5.18327C9.89598 5.21955 9.85538 5.25074 9.80804 5.27493Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.956bc23e84c50075cafa08375db02b45.svg";
export { ForwardRef as ReactComponent };